import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { FormValidationUtils } from '../../../utils/form-validation-utils';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lib-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
  imports: [MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormErrorComponent {
  errors = input.required<ValidationErrors | null | undefined>();

  private defaultErrorMessages = FormValidationUtils.DEFAULT_FORM_ERROR_MESSAGES;

  displayErrorMessage = computed(() => {
    const errors = this.errors();
    if (!errors || Object.keys(errors).length === 0) {
      return '';
    }

    const errorKey = Object.keys(errors)[0];
    const errorValue = Object.values(errors)[0];
    let errorMessageString: string | null = null;
    if (typeof errorValue === 'string') {
      errorMessageString = errorValue;
    }

    return errorMessageString ?? this.defaultErrorMessages[errorKey] ?? '';
  });
}
